import React, { FunctionComponent, ReactNode } from 'react';

import cn from 'classnames';

import css from './styles.css';

interface ConditionalContentRendererProps {
    condition: boolean;
    content: ReactNode;
    fallback: ReactNode;
}

export const ConditionalContentRenderer: FunctionComponent<ConditionalContentRendererProps> = ({
    condition,
    content,
    fallback,
}) => {
    return (
        <div className={css.container}>
            <div className={cn({ [css.hidden]: condition })}>{fallback}</div>
            <div className={cn({ [css.hidden]: !condition })}>{content}</div>
        </div>
    );
};
